export default {
  isError(data) {
    if (typeof data.data !== 'undefined') {
      data = data.data
    }

    if (typeof data.success !== 'undefined') {
      if (!data.success) {
        let message = ''

        try {
          for (let error in data.errors) {
            message += data.errors[error]
            message += '\r\n'
          }
        } catch (e) {
          message = 'Неизвестная ошибка'
        }

        return {
          isError: true,
          message,
        }
      }
    }

    if (typeof data.errors !== 'undefined') {
      let message = ''

      try {
        for (let error in data.errors) {
          message += data.errors[error]
          message += '\r\n'
        }
      } catch (e) {
        message = 'Неизвестная ошибка'
      }

      return {
        isError: true,
        message,
      }
    }

    return {
      isError: false,
    }
  },
}
